<template>
    <div class="company-select__root">
        <ba-header :disableMenu="true"></ba-header>
        <div class="main-content">
        <div class="u-text--center u-mb4">Please choose your company</div>
          <div class="company-select__sort u-p4">
            <el-input type="text" placeholder="Search..." v-model="searchText"></el-input>
            <ba-company-select-component
              :availableCompanies="availableCompanies"
              @onChangeCompaniesList="updateCompaniesList"
            />
            <el-button type="danger"
                       class="u-ml4"
                       v-if="isSuperUser && !isFeatureEnabled('is-dev') && !isFeatureEnabled('is-local')"
                       @click="showCloneCompanyDialog=true">
                Clone Company
            </el-button>
            <el-button type="danger"
                       class="u-ml4"
                       v-if="isSuperUser && (isFeatureEnabled('is-dev') || isFeatureEnabled('is-local'))"
                       @click="showCreateCompanyDialog=true">
                Create Company
            </el-button>            
          </div>
        <div class="u-p4">
            <div class="my-grid" :class="{'my-grid--no-results' : noResults}">
                <div class="company-select__no-results" v-if="noResults">
                    <div class="no-results__text u-mb4">No results</div>
                    <el-button @click="clearSearch()">Clear</el-button>
                </div>
                <div class="my-grid__element company-link"
                             v-for="company in visibleCompanies"
                             v-if="company.name.toLowerCase().indexOf(searchText) >= 0">

                        <el-button class="company-select__button" :class="{ 'company-inactive' : !company.enabled}">
                            <div class="company-select__row">
                                <div class="row__healtcheck">
                                    <ba-healthcheck-status :healthcheck="healthcheckByCompany(company.id)">
                                    </ba-healthcheck-status>
                                </div>
                                <div v-if="isSuperUser" class="edit-company">
                                  <el-button @click="updateCompany(company)" class="edit-company__button">Update</el-button>
                                </div> 
                                <div>
                                  <router-link :key="company.id" :to="'/company/'+ company.id +'/'">
                                    <div class="company-select__name">
                                        {{company.name}}
                                    </div>
                                  </router-link>
                                </div>
                            </div>
                            <div class="company-image-container">
                                <img  class="company-select__button_pict"
                                      :class="{'company-inactive__image': !company.enabled}"
                                      :src="apiRoot + '/get_image/logo/'+ company.id" />
                                <div v-if="!company.enabled" class="inactive-company-warning">DISABLED</div>
                            </div>
                            <div class="company-select_website-block">
                                <a :href="company.website_url" target="_blank" title="Will open in new tab">{{ company.website_url }}</a>
                            </div>

                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <ba-clone-company-dialog v-model="showCloneCompanyDialog"></ba-clone-company-dialog>
        <ba-create-company-dialog v-model="showCreateCompanyDialog"></ba-create-company-dialog>
        <ba-update-company-dialog v-model="showUpdateCompanyDialog"
                                  :id='updateCompanyId'
                                  :name='updateCompanyName'
                                  :britecoreURL='updateCompanyURL'
                                  :enabled="updateCompanyEnabled"></ba-update-company-dialog>
    </div>
</template>

<script>
  import {mapGetters, mapActions, mapState} from 'vuex'
  import config from '@/config'
  import HealthcheckStatusComponent from '../../components/healthcheck-status.component.vue'
  import BaCompanySelectComponent from '../../components/company-select.component'
  import CloneCompanyDialogComponent from './clone-company.dialog.component.vue'
  import CreateCompanyDialogComponent from './create-company.dialog.component.vue'
  import UpdateCompanyDialogComponent from './update-company.dialog.component.vue'

  export default {
    name: 'ba-company-select',
    components: {
      'ba-healthcheck-status': HealthcheckStatusComponent,
      BaCompanySelectComponent,
      'ba-clone-company-dialog': CloneCompanyDialogComponent,
      'ba-create-company-dialog': CreateCompanyDialogComponent,
      'ba-update-company-dialog': UpdateCompanyDialogComponent,
    },
    computed: {
      ...mapGetters('shared', ['availableCompanies', 'healthcheckByCompany', 'isFeatureEnabled']),
      ...mapState('shared', ['user']),
      isSuperUser () {
        return ((this.user !== undefined) && (this.user !== null)) ? this.user.is_superuser : false
      },
      apiRoot () {
        return config.url
      },
      noResults () {
        return this.availableCompanies.filter(_ => _.name.toLowerCase().indexOf(this.searchText) >= 0).length === 0
      }
    },
    methods: {
      ...mapActions('login', ['init']),
      ...mapActions('shared', ['loadHealthcheck']),
      clearSearch () {
        this.searchText = ''
      },
      updateCompaniesList (val) {
        this.visibleCompanies = val
      },
      updateCompany (company) {
        this.updateCompanyId = company.id
        this.updateCompanyName = company.name
        this.updateCompanyURL = company.britecore_url
        this.updateCompanyEnabled = company.enabled
        this.showUpdateCompanyDialog=true
      },
    },
    data () {
      return {
        searchText: '',
        visibleCompanies: [],
        showCloneCompanyDialog: false,
        showCreateCompanyDialog: false,
        showUpdateCompanyDialog: false,
        updateCompanyId: null,
        updateCompanyName: null,
        updateCompanyURL: null,
        updateCompanyEnabled: null,
      }
    },
    created () {
      this.init()
      this.loadHealthcheck()
    },
  }
</script>

<style lang="scss" scoped>
    .my-grid {
        display: grid;
        grid-gap: 2em;

        grid-template-columns: 1fr 1fr 1fr;
        align-items: center;

        @media only screen and (max-width: 768px) {
            grid-template-columns: 1fr;
        }

    }
    .my-grid--no-results {
        display: block;

    }
    .company-select {
        overflow: hidden;

    }

    .company-select__root {
    }

    .company-select__button {
        display: block;
        width: 100%;
        &_pict {
            height: 3em;
        }
        cursor: unset;
    }

    .company-inactive__image {
      filter: grayscale(100%)
    }
    .company-select__button:hover {
      background: #FFFFFF !important;
    }

    .company-select__button.company-inactive:hover {
      background-color: lightgrey !important;
    }

    .company-select__row {
        position: relative;

    }
    .row__healtcheck {
        position: absolute;
        top: 0;
        left: 0;
    }



    .company-select__name {
        border-bottom: solid 1px rgba(0, 0, 0, 0.19);
        margin-bottom: 1em;
        font-size: 1.2em;
        padding-bottom: 1em;
        font-weight: 600;
    }

    .company-select_website-block {
        border-top: solid 1px rgba(0, 0, 0, 0.19);
        margin-top: 1em;
        font-size: 1.2em;
        padding-top: 1em;
        font-weight: 600;
    }
    .company-link {

        animation: slideIn 1.5s ease-out;
        @media only screen and (max-width: 768px) {
            display: block;
            width: 100%;
        }

    }

    @keyframes slideIn {
        from { opacity: 0 }
        to { opacity: 1 }
    }
    .company-select__no-results {
        visibility: hidden;

        font-size: 2em;
        text-align: center;
        color: #888888;

    }
    .no-results__text {

    }
    .company-select__no-results:only-child{
        visibility: visible;
    }
    .company-select__sort {
        display: flex;
        align-items: center;
    }

    .edit-company {
      float: right;
    }

    .edit-company__button {
      font-size: x-small;
      height: 20px;
      line-height: 0;
      display: inline-flex !important;
      align-items: center;
    }

    .company-inactive {
        background-color: lightgrey;
    }

    .inactive-company-warning {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
      color: red;
      font-size: 40px;
    }

    .company-image-container {
      position: relative;
      text-align: center;
      color: white;
    }

</style>
